<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background col-8-center">
  <div class="print">
    @switch (printButtonExperienceType) {
      @case ('special-enrollment') {
        <app-populated-special-enrollment-form-print></app-populated-special-enrollment-form-print>
      }
      @case ('enhanced-pdf-print') {
        <app-submitted-application-pdf-print></app-submitted-application-pdf-print>
      }
      @default {
        <app-print-button></app-print-button>
      }
    }
  </div>
  <h1>Application Summary</h1>
  <div>
    <div class="heading">Application Submission Number</div>
    <div class="sub-heading">{{confirmationAppId}}</div>
    <div class="heading">Plan Name</div>
    <div class="sub-heading">{{planName}}</div>
    @if (showEffectiveDate) {
      <div class="heading">Effective Date</div>
    }
    @if (showEffectiveDate) {
      <div class="sub-heading">{{effectiveDate}}</div>
    }

    @if (submittedDate) {
      <div class="heading">Date Submitted</div>
      <div class="sub-heading">{{submittedDate}}</div>
    }
  </div>

  <div>
    <!--
    @TODO - confirm the below statements, I'm 99% certain they are true. Devon: 2025-01-10
    Pretty sure these properties do NOT carry over, at all, down into angular components and that this is a copy/paste
    mistake from AEM

    Also, this should likely just be "app-plan-enrollment-form" as it's not replacing itself externally
    -->
    <sxe-plan-enrollment-form
      form-type="${properties.formType}"
      user-type="${properties.userType}"
      confirmation-page-url="${properties.confirmationPageUrl}"
      ma-confirmation-page-url="${properties.maConfirmationPageUrl}"
      medigap-confirmation-page-url="${properties.medigapConfirmationPageUrl}"
      whb-confirmation-page-url="${properties.whbConfirmationPageUrl}"
      pdp-confirmation-page-url="${properties.pdpConfirmationPageUrl}"
      save-for-later-page-url="${properties.saveForLaterPageUrl}"
      registration-url="${properties.registrationUrl}"
      forgot-password-url="${properties.forgotPasswordUrl}"
      button-url="${properties.buttonUrl}"
      sub-product-type-order="${formContainerConfig.productPriorityJsonMap}"
      product-type-tab-config="${formContainerConfig.productTypeTabConfigJsonMap}"
      is-review-only="true">
    </sxe-plan-enrollment-form>
  </div>

  @if (hasDrugInfo) {
    <div class='drug-coverage-container col-12'>
      <app-toggle-radio></app-toggle-radio>
      <app-pharmacy-detail></app-pharmacy-detail>
      <app-total-drug-cost></app-total-drug-cost>
    </div>
  }
</div>
